export const blogPosts = [
  {
    slug: "disciplined-problem-solving",
    title: "Disciplined Problem-Solving That Scales",
    excerpt:
      "A practical framework for consistent execution across teams without adding complexity.",
    date: "2026-01-03",
    readTime: "5 min read",
    category: "Operational Excellence",
    cover: "/blog/cover-1.jpg"
  },
  {
    slug: "audit-ready-without-chaos",
    title: "Audit-Ready Without the Chaos",
    excerpt:
      "How to build governance, documentation, and routines that stay clean year-round.",
    date: "2025-12-19",
    readTime: "6 min read",
    category: "Compliance",
    cover: "/blog/cover-2.jpg"
  },
  {
    slug: "training-for-adoption",
    title: "Training That Drives Adoption",
    excerpt:
      "Move beyond workshops: coaching loops, standard work, and reinforcement that sticks.",
    date: "2025-12-01",
    readTime: "4 min read",
    category: "Training",
    cover: "/blog/cover-3.jpg"
  }
];
